export class AysDrgBaseRateStore {

  constructor(
    private readonly _baseUrl: string
  ) {
  }

  public index(): string {
    const baseUrl = this._baseUrl;

    return `${baseUrl}/base_rates/`;
  }
}
